import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  title: {
    fontFamily: "Inter",
    fontSize: rem(18),
    fontWeight: 600,
    marginTop: rem(20),
  },
  header: {
    border: "10px solid var(--app-surface-2)",
    paddingTop: rem(10),
  },
  headerTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: rem(10),
    margin: rem(40),
  },
  select: {
    fontFamily: "Inter",
    "& .mantine-Select-wrapper": {
      marginTop: "6px",
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    },
    "& input": {
      border: "none",
      backgroundColor: "transparent",
      paddingBlock: "10px",
      paddingLeft: "14px",
      height: "44px",
    },
    "& .mantine-Select-rightSection": {
      width: "fit-content",
      height: "inherit",
      marginRight: "14px",
    },
  },
  input: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "var(--app-text)",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  supportDetailRightButtons: {
    background: "transparent",
    // height: "100px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "0 5px",
    gap: "10px",
  },
  keyStepsBox: {
    width: "100%",
    height: "100%",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface-2)",
    paddingBottom: "12px",
  },
  keyStepsText: {
    background: "var(--app-surface-2)",
    marginBottom: "14px",
    padding: "8px 18px",
  },
  supportDetailAdditionButton: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",

    // marginRight: "250px",
  },

  headerContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "24px",
    padding: "14px 12px",
    width: "100%",
    borderRadius: "12px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    "& img": {
      width: rem(30),
    },
    "& > div": {
      flex: 1,
    },
    "@media (max-width: 1024px)": {
      gap: rem(30),
    },
    "@media (max-width: 600px)": {
      flexDirection: "column",
      "& > div": {
        width: "100%",
        flex: "unset",
      },
    },
  },
  bodyContent: {
    width: "100%",
    fontFamily: "Inter",
    marginTop: "22px",
    "& img": {
      width: rem(30),
    },
  },
  supportPlaneTopSection: {
    paddingBottom: 30,
    display: "flex",
    gap: 20,
    alignItems: "center",
    justifyContent: "space-around",
    paddingInline: 30,
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      paddingInline: 0,
      gap: 10,
    },
  },
  outcomeDeleteBTN: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    borderRadius: "8px",
    background: "var(--app-surface-2)",
    padding: "8px",
    "& .mantine-Button-root": {
      display: "flex",
      alignItems: "center",
      background: "transparent",
      padding: "8px 0px",
      width: "auto",
      height: "auto",
      "& .mantine-Button-label": {
        display: "flex",
        alignItems: "center",
        fontWeight: 600,
        gap: 4,
        fontSize: "16px",
        color: "#F04438",
        fontFamily: "Inter",
      },
    },
  },
  activitiesBox: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface-2)",
    overflow: "hidden",
    // background: "red",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      paddingInline: 0,
      gap: 0,
    },
  },
  activityBoxHeader: {
    width: "100%",
    display: "flex",
    background: "var(--app-surface-2)",
    padding: "8px 18px",
    justifyContent: "space-between",
    alignItems: "center",
    "& p": {
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 600,
      margin: 0,
    },
  },
  activityFields: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    padding: "14px 20px 12px 20px",
  },
  activityInputs: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    gap: "14px",
    "@media (max-width: 600px)": {
      "& .textArea": {
        width: "100%",
      },
    },
  },
  // activitiesTextBox: {
  //   width: "34%",
  //   "@media (max-width: 600px)": {
  //     width: "100%",
  //   },
  // },
  outcomeNumberSection: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "35px",
  },
  buttonBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "1rem",
    margin: "2rem auto",
  },

  textInputBox: {
    width: "100%",
    border: "1px solid rgba(0,0,0,0.1)",
    padding: "5px 15px",
    borderRadius: "15px",
    position: "relative",
    "& textarea[disabled]": {
      backgroundColor: "var(--app-surface) !important",
    },
    "& .mantine-Textarea-input": {
      border: "none",
      paddingInline: "0",
    },
    "& .label": {
      position: "absolute",
      top: -10,
      left: 15,
      zIndex: 100,
      color: "var(--app-text)",
      margin: 0,
      backgroundColor: "var(--app-surface)",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: 500,
      paddingInline: "10px",
    },
  },
  frequencyAndByWhen: {
    width: "100%",
    display: "flex",
    gap: "36px",
    justifyContent: "space-between",
    alignItems: "baseline",
    "@media (max-width:768px)": {
      flexDirection: "column",
      gap: 14,
      "& > div": {
        width: "100%",
      },
    },
  },
  byWhenDateElem: {
    marginTop: "15px",
  },
  essentialSupportRadio: {
    padding: "14px",
    width: "292px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    "& .mantine-Radio-root": {
      flex: 1,
    },
    "& .mantine-Radio-body .mantine-Radio-label": {
      paddingLeft: "8px",
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  essentialSupportFieldBox: {
    borderRadius: "12px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    padding: "14px 12px",
  },
  // segment: {
  //   "& .mantine-p2ocmu": {
  //     borderRadius: "1rem 0 0 1rem !important",
  //   },
  // },
  essentialActivities: {
    border: "1px solid rgba(0,0,0,0.1)",
    width: "100%",
    height: "auto",
    borderRadius: "5px",
  },
  oneA: {
    backgroundColor: "var(--app-surface-2)",
    padding: "5px 15px",
  },
  statementAndSupport: {
    padding: "10px 15px",
    backgroundColor: "var(--app-surface-2)",
  },
  statementSupportParent: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    "@media (max-width:992px)": {
      display: "block",
      textAlign: "-webkit-center",
    },
  },
  statementSupportTextArea: {
    width: "100%",
    backgroundColor: "var(--app-surface-2)",
    borderRadius: "5px",
  },
  supportBox: {
    width: "100%",
    "@media (max-width:992px)": {
      width: "100%",
      textAlign: "start",
    },
  },
  instructionsBox: {
    "@media (max-width:992px)": {
      marginTop: "10px",
    },
  },
  addSupportDetails: {
    width: "100%",
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    borderRadius: "5px",
    fontSize: "small",
    marginTop: "10px",
    padding: "10px 0",
    border: "none",
    cursor: "pointer",
  },
  saveButton: {
    width: "100%",
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    borderRadius: "5px",
    fontSize: "small",
    marginTop: "10px",
    padding: "15px 0",
    border: "none",
    cursor: "pointer",
  },
  addNewActivityParent: {
    textAlign: "right",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    padding: "10px 0",
  },
  addNewActivity: {
    border: "none",
    backgroundColor: "var(--app-primary)",
    cursor: "pointer",
    color: "var(--app-on-primary)",
    fontSize: "25px",
    fontWeight: "bold",
    borderRadius: "3px",
    marginTop: "10px",
    "&:hover": {
      backgroundColor: "var(--app-primary)",
    },
  },
  addInfo: {
    marginTop: "5px",
  },
  onLoadingDisable: {
    cursor: "not-allowed",
    backgroundColor: "var(--app-surface-2)",
  },
  essentialSupportNumberBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "9px 13px",
    gap: "10px",
    borderRadius: "8px",
    background: "var(--app-surface-2)",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "& .mantine-Input-input": {
      textAlign: "center",
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: 400,
    },
  },

  reassessDatesContainer: {
    width: "100%",
    padding: "14px 12px",
    borderRadius: 12,
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
  },

  reassessDateLabel: {
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 600,
    color: "var(--app-text)",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px",
    borderRadius: 8,
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05), 0 0 0 4px var(--app-border)",
  },

  // ********************** drawer styling *********************
  drawer: {
    "& .mantine-Drawer-content": {
      borderRadius: "16px",
      backgroundColor: "var(--app-surface-2)",
    },
    "& .mantine-Drawer-body": {
      padding: "27px 27px 15px 27px !important",
      "@media (max-width: 600px)": {
        padding: "16px 12px 10px 12px !important",
      },
    },
    "& .mantine-Drawer-header": {
      backgroundColor: "var(--app-surface)",
      padding: "19px 13px",
      // position: "sticky",
      // top: 0,
      // zIndex: 10,
      // borderBottom: "1px solid var(--app-border)",
    },
    "& .mantine-Drawer-title": {
      fontSize: "24px",
      fontWeight: "700",
      color: "var(--app-text)",
      fontFamily: "Inter",
    },
  },
  dateRangePicker: {
    fontFamily: "Inter",
    "& .mantine-Input-wrapper": {
      marginTop: "6px",
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",

      "& .mantine-DatePickerInput-input": {
        padding: "10px 14px",
      },
      "& .mantine-Input-input": {
        backgroundColor: "transparent",
        border: "none",
        height: "44px",
        color: "var(--app-text)",
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 600,
      },
    },
  },
  errorBorder: {
    "& .mantine-Input-wrapper": {
      border: "2px solid red",
    },
  },
  accordianParent: {
    borderRadius: "12px",
    border: "1px solid var(--app-border)",
    padding: "0px 13px",
    background: "var(--app-surface)",
  },
  accordion: {
    "& .mantine-Accordion-control": {
      borderBottom: "1px solid var(--app-border)",
      "& .display-on-close": {
        display: "none !important",
      },
      '&[aria-expanded="false"] .display-on-close': {
        display: "block !important",
      },
      '&[aria-expanded="true"] .display-on-close': {
        display: "none !important",
      },
    },
    "& .mantine-Accordion-content": {
      padding: "0px 0px 24px 0px",
      "& > .contentParent": {
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        paddingTop: "24px",
      },
    },
    "& .mantine-Accordion-item:last-child": {
      borderBottom: "none",
    },
  },
  outcomeNumberInput: {
    width: "100%",
    "& .mantine-Input-input": {
      textAlign: "center",
      background: "transparent",
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: 400,
    },
    "& .mantine-Input-input:focus": {
      border: "none !important",
    },
    "& .mantine-Input-wrapper": {
      padding: "9px 13px",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      borderRadius: "8px",
      background: "var(--app-surface-2)",
    },
    "& .mantine-Input-rightSection": {
      marginRight: "13px",
    },
    "& .mantine-Input-icon": {
      marginLeft: "13px",
      pointerEvents: "unset",
    },
    "& .mantine-InputWrapper-label": {
      color: "var(--app-text)",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  inc_dec_Btn: {
    borderRadius: "50%",
    height: "26px",
    width: "26px",
    backgroundColor: "var(--app-surface)",
    filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
    padding: "0px",
    "&:hover": {
      backgroundColor: "var(--app-surface)",
    },
  },
  textArea: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        padding: "10px 14px",
        color: "var(--app-text-muted)",
        fontSize: "12px",
        fontWeight: 400,
        height: "150px",
        borderRadius: "8px",
        background: "var(--app-surface-2)",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "var(--app-text)",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  checkboxGroup: {
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface-2)",
    padding: "8px 0px 8px 14px",
    gap: 24,
    "& .mantine-Checkbox-body": {
      flexDirection: "column-reverse",
      gap: "4px",
    },
    "& .mantine-Checkbox-label": {
      padding: "0px",
      color: "var(--app-text-muted)",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 400,
    },
  },
  addNewActivityBtn: {
    width: "100%",
    backgroundColor: "var(--app-primary)",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "16px",
    fontFamily: "Inter",
    paddingBlock: "8px",
    height: "48px",
    "& .mantine-Button-label": {
      gap: 4,
    },
    "&:hover": {
      backgroundColor: "var(--app-primary)",
    },
  },
  addAndSaveBtnParent: {
    display: "flex",
    padding: "24px 0px 12px 0px",
    borderTop: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    alignItems: "center",
    gap: "16px",
    width: "100%",
    "& button": {
      borderRadius: "8px",
      paddingBlock: "16px",
      fontFamily: "Inter",
      height: "auto",
      fontSize: "18px",
      fontWeight: 600,
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    },
    "@media (max-width: 600px)": {
      flexDirection: "column",
      gap: "8px",
      "& button": {
        width: "100%",
        fontSize: "15px",
        paddingBlock: "12px",
      },
    },
    "& .addBtn": {
      flex: 1,
      color: "var(--app-text)",
      border: "1px solid var(--app-border)",
      background: "var(--app-surface-2)",
    },
    "& .saveBtn": {
      flex: 1,
      borderRadius: "8px",
      border: "1px solid var(--app-primary)",
      background: "var(--app-primary)",
    },
  },
  profile_container: {
    borderRadius: "6px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    padding: "12px 12px 20px 12px",
    marginBottom: "16px",
    "& .profileFlex": {
      marginBottom: "16px",
      paddingBottom: "16px",
      borderBottom: "1px solid var(--app-border)",
    },
    "& .img": {
      width: "68px",
      height: "68px",
      borderRadius: "50%",
      top: "0px !important",
    },

    "& .name": {
      marginBottom: "0px !important",
      marginTop: "0px",
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 600,
    },

    "& .id": {
      marginTop: "0px",
      textTransform: "uppercase",
      color: "var(--app-text-muted)",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 400,
      marginBottom: "0px",
    },

    "& .label": {
      margin: "0px",
      color: "var(--app-text-muted)",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 400,
    },
  },
  editBtnBox: {
    height: "100%",
    width: "fit-content",
    "& button": {
      padding: "0px",
      height: "auto",
      "& .mantine-Button-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "4px",
        fontFamily: "Inter",
        fontSize: "15px",
        fontWeight: 600,
        color: "var(--app-primary)",
      },
    },
  },

  // ************************* Effective Period Date Picker Styling ******************************

  buttonStyle: {
    fontFamily: "Inter",
    backgroundColor: "var(--app-surface)",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    height: "44px",
    padding: "10px 14px",
    color: "var(--app-text)",
    marginTop: "6px",
    width: "100%",
    "&:hover": {
      backgroundColor: "var(--app-surface)",
    },
  },
  datePickerParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width:834px)": {
      display: "block",
    },
  },
  popOverCard: {
    "@media (max-width:992px)": {
      left: "250px !important",
    },
    "@media (max-width:600px)": {
      left: "18px !important",
    },
    "@media (max-width:360px)": {
      left: "0px !important",
    },
  },
  buttonsParent: {
    borderRight: "1px solid var(--app-border)",
    display: "flex",
    flexDirection: "column",
    padding: "0 10px 0 0",
    "@media (max-width:834px)": {
      borderRight: "none",
    },
  },
  datePickerParentDiv: {
    // padding: "10px 0 10px 0",
  },
  datePicker: {
    padding: "0 10px 0 10px",
  },

  dateButtons: {
    width: "auto",
    marginTop: "12px",
    transition: "0.5s",
    backgroundColor: "transparent",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
      color: "var(--app-text)",
    },
    color: "var(--app-text)",
    "@media (max-width:834px)": {
      backgroundColor: "var(--app-primary)",
      color: "var(--app-on-primary)",
    },
  },
  activeButton: {
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    "&:hover": {
      backgroundColor: "var(--app-primary)",
      color: "var(--app-on-primary)",
    },
  },
  bottomButtonsParent: {
    borderTop: "1px solid var(--app-border)",
    paddingTop: "10px",
  },
  bottomButtons: {
    marginLeft: "15px",
  },
  cancelButton: {
    backgroundColor: "var(--app-surface-2)",
    color: "var(--app-text)",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },
  applyButton: {
    backgroundColor: "var(--app-primary)",
    width: "55%",
    "&:hover": {
      backgroundColor: "var(--app-primary)",
    },
  },
  iconCalendar: {
    margin: "0 10px 0 0",
  },
}));

export default useStyles;
